import React, { useMemo } from 'react';
import Item from './Item';
import { useSelector } from 'react-redux';
import { getAccountAvatars } from '../../../../store/selectors';

const renderItem = (avatarList) => (data) => (
    <Item data={data} key={`${data.clubId}${data.accountId}`} avatar={avatarList[data.accountId] || null} />
);

const ItemList = ({ data }) => {
    const avatarList = useSelector(getAccountAvatars);
    const renderItemFn = useMemo(() => renderItem(avatarList), [avatarList]);

    return (
        <div className={`clubDataItemList`}>
            { !!data &&  data.length > 0 &&
                data.map(renderItemFn) 
            }
        </div>
    );
}

export default ItemList;